var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AwlCard',{staticClass:"awl-modal-card",attrs:{"border":_vm.border,"box-shadow":"","title":_vm.title}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }